<app-langding-page-nav-bar></app-langding-page-nav-bar>

<div class="help-page-container">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">How can we help you?</h1>
      <p class="hero-subtitle">Find answers, watch tutorials, and get support for all Gigsumo features</p>
      
      <!-- Search Bar -->
      <div class="search-container">
        <div class="search-box">
          <ng-icon name="tablerSearch" class="search-icon"></ng-icon>
          <input type="text"
                 [formControl]="searchControl"
                 class="form-control search-input"
                 placeholder="Search for help topics, tutorials, or features..."
                 (keyup.enter)="searchFilter()">
        </div>
        <button class="btn primary-btn" (click)="searchFilter()" [disabled]="!searchControl.value">
          Search
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <!-- Quick Actions -->
    <div class="quick-actions">
      <div class="quick-action-item" (click)="ContactAdmin()">
        <div class="action-icon">
          <ng-icon name="customDoubt"></ng-icon>
        </div>
        <h3>Contact Support</h3>
        <p>Get personalized help from our team</p>
      </div>
      <div class="quick-action-item" (click)="searchFilter()">
        <div class="action-icon">
          <ng-icon name="tablerSearch"></ng-icon>
        </div>
        <h3>Search Help</h3>
        <p>Find answers to specific questions</p>
      </div>
    </div>

    <!-- Tutorial Categories -->
    <div class="categories-section custom-shadow">
      <h2 class="section-title">Browse by Category</h2>
      
      <mat-tab-group class="modern-tabs" (selectedTabChange)="selectTab($event)" [(selectedIndex)]="selectedIndex">
        <mat-tab *ngFor="let tab of tabs" [label]="tab">
          <ng-template matTabContent>
            <div class="tutorials-container">
              <!-- Loading State -->
              <div class="loading-container" *ngIf="loadAPIcall">
                <ng-container *ngFor="let item of 5 | times; let i = index">
                  <app-common-skeleton [NameOftheScreen]="'helpModule'"></app-common-skeleton>
                </ng-container>
              </div>

              <!-- Video Gallery -->
              <div class="video-gallery" *ngIf="!loadAPIcall">
                <div class="video-card-modern" 
                     *ngFor="let video of helpDetails; let i = index"
                     (click)="openVideo(video, templateVideo)"
                     title="{{video?.question}}">
                  
                  <div class="video-thumbnail-modern">
                    <video class="video-element" #videoElements>
                      <source [src]="video?.answer" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>
                    
                    <div class="play-overlay">
                      <div class="play-btn-modern">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      </div>
                    </div>
                    
                    <div class="video-duration" *ngIf="video?.duration">
                      {{video?.duration}}
                    </div>
                  </div>
                  
                  <div class="video-content">
                    <h3 class="video-title">{{video?.question}}</h3>
                  </div>
                </div>

                <!-- Empty State -->
                <div class="empty-state" *ngIf="helpDetails.length === 0">
                  <div class="empty-icon">📹</div>
                  <h3>No tutorials found</h3>
                  <p>We're working on adding more content for this category.</p>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>

    <!-- Help Footer -->
    <div class="help-footer">
      <div class="help-cta">
        <div class="cta-content">
          <div class="cta-icon">
            <ng-icon name="customDoubt"></ng-icon>
          </div>
          <div class="cta-text">
            <h3>Still need help?</h3>
            <p>Our support team is here to assist you with any questions</p>
          </div>
          <button class="btn primary-btn cta-button" (click)="ContactAdmin()">
            Get Support
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Enhanced Video Modal -->
<div class="video-modal-overlay" *ngIf="isVideoPaused" (click)="closeModel()">
  <div class="video-modal-content" (click)="$event.stopPropagation()">
    <div class="video-modal-header">
      <h3 class="video-modal-title">{{seletedVideo?.question}}</h3>
      <button class="modal-close-btn" (click)="closeModel()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    
    <div class="video-modal-body">
      <video class="modal-video" autoplay #videoPlayernew controls id="videofile">
        <source [src]="seletedVideo?.answer" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</div>



<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" style="z-index: -1;"
  [messageDataPass]="messageData"> </app-message-widget>
